import React from 'react';
import { GenericPage } from './GenericPage';
import { HeatmapGraphic } from '../components/Graphics';
export function BAS() {
  return <GenericPage hero={{
    eyebrow: 'Picus Platform',
    headline: 'Prove your controls work',
    subhead: 'Picus BAS helps teams validate whether prevention and detection controls are doing what they are supposed to do. It is the fastest way to answer a simple question buyers already care about: is the stack we bought actually working?',
    primaryCta: {
      label: 'Get a BAS Demo',
      to: '/contact'
    },
    secondaryCta: {
      label: 'Start a Trial',
      to: '/free-trial'
    },
    graphic: <HeatmapGraphic data-id="element-330" />
  }} modules={[{
    title: 'Continuous BAS beats periodic BAS',
    subtitle: 'BAS is not outdated. Periodic, isolated BAS is. Picus helps teams validate controls continuously so they can catch gaps sooner and tune faster.',
    type: 'cards',
    cards: [{
      title: 'Calendar-based testing',
      description: 'Testing happens quarterly regardless of environment changes.'
    }, {
      title: 'Continuous validation',
      description: 'Rolling validation pulses catch drift immediately.'
    }],
    graphic: 'Calendar-based testing on left, rolling validation pulses on right.'
  }, {
    title: 'Validate prevention and detection with evidence',
    subtitle: 'Picus shows where defenses hold and where they fail. That helps teams tune the controls they already own instead of guessing where the problem might be.',
    type: 'text',
    graphic: 'Pass/fail simulation scorecards across major control layers.'
  }, {
    title: 'Security Control Validation starts here',
    subtitle: 'Breach and Attack Simulation powers Security Control Validation by running real attack scenarios and collecting measurable evidence of control effectiveness. It does not guess. It measures.',
    type: 'text',
    graphic: 'BAS node flowing into Security Control Validation node with an evidence badge.'
  }, {
    title: 'Test the threats that matter now',
    subtitle: 'Picus BAS supports validation across malware, endpoint, network, web, email, DLP, and URL filtering use cases. It is built for teams that need a current read on readiness, not just a quarterly snapshot.',
    type: 'text',
    graphic: 'Threat library panel with a live new threat pulse.'
  }, {
    title: 'A strong first step into autonomous validation',
    subtitle: 'For most buyers, BAS is still the clearest starting point. Picus Platform turns that familiar entry motion into a stronger path toward broader, signal-driven, autonomous exposure validation.',
    type: 'text',
    graphic: 'BAS tile expanding into the broader platform map.'
  }, {
    title: 'Confidence for the stack you already bought',
    subtitle: 'Security teams spend millions on controls and still lack proof. Picus BAS helps turn that investment into evidence.',
    type: 'text',
    graphic: 'Control investment → validated result loop.',
    proof_chips: ['Validate controls continuously', 'Improve readiness against real attack behavior', 'Tune detections and prevention with evidence']
  }]} data-id="element-329" />;
}